/* Custom mega menu */
document.addEventListener("DOMContentLoaded", () => {
  const megaMenuItems = document.querySelectorAll(".header__inline-menu .mega-menu");
  const buffer = 20;
  let currentOpenMenu = null;

  function closeMegaMenus() {
    megaMenuItems.forEach(item => item.removeAttribute("open"));
  }

  function isMouseNear(mouseEvent, element) {
    const rect = element.getBoundingClientRect();
    return (
      mouseEvent.clientX >= rect.left - buffer &&
      mouseEvent.clientX <= rect.right + buffer &&
      mouseEvent.clientY >= rect.top - buffer &&
      mouseEvent.clientY <= rect.bottom + buffer
    );
  }

  function handleMouseMove(event) {
    if (currentOpenMenu) {
      const nearCurrent = isMouseNear(event, currentOpenMenu);
      const content = currentOpenMenu.querySelector('.mega-menu__content');
      const contentRect = content.getBoundingClientRect();
      const inContentArea =
        event.clientX >= contentRect.left &&
        event.clientX <= contentRect.right &&
        event.clientY >= contentRect.top &&
        event.clientY <= contentRect.bottom;

      if (!nearCurrent && !inContentArea) {
        currentOpenMenu.removeAttribute('open');
        currentOpenMenu = null;
        document.removeEventListener('mousemove', handleMouseMove);
      }
    }
  }

  function handleMouseLeaveDocument(event) {
    if (currentOpenMenu) {
      currentOpenMenu.removeAttribute('open');
      currentOpenMenu = null;
      document.removeEventListener('mousemove', handleMouseMove);
    }
  }

  megaMenuItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      if (currentOpenMenu && currentOpenMenu !== item) {
        currentOpenMenu.removeAttribute("open");
      }
      item.setAttribute("open", true);
      currentOpenMenu = item;
      document.addEventListener('mousemove', handleMouseMove);
    });

    item.addEventListener("mouseleave", () => {
      if (currentOpenMenu === item) {
        const content = item.querySelector('.mega-menu__content');
        if (!isMouseNear(event, content)) {
          item.removeAttribute("open");
          currentOpenMenu = null;
          document.removeEventListener('mousemove', handleMouseMove);
        }
      }
    });

    const links = item.querySelectorAll(".mega-menu__link");

    links.forEach(link => {
      link.addEventListener("focus", () => {
        item.setAttribute("open", true);
        currentOpenMenu = item;
      });

      link.addEventListener("blur", () => setTimeout(() => {
        if (!item.contains(document.activeElement)) {
          item.removeAttribute("open");
          currentOpenMenu = null;
        }
      }, 10));
    });
  });

  document.addEventListener('mouseleave', handleMouseLeaveDocument);
});






/* Custom quickshop */
document.addEventListener('click', function(event) {
  var sizeElement = event.target.closest('.custom-product-size');
  if (!sizeElement) return;

  var variantId = sizeElement.dataset.variantId;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    return fetch(window.Shopify.routes.root + 'cart.js');
  })
  .then(response => response.json())
  .then(cartData => {
      let cartCountBubble = document.querySelector('.cart-count-bubble span');
      if (!cartCountBubble) {
        const cartCountBubbleContainer = document.createElement('div');
        cartCountBubbleContainer.className = 'cart-count-bubble';
        cartCountBubble = document.createElement('span');
        cartCountBubble.setAttribute('aria-hidden', 'true');
        cartCountBubbleContainer.appendChild(cartCountBubble);

        const visuallyHiddenSpan = document.createElement('span');
        visuallyHiddenSpan.className = 'visually-hidden';
        visuallyHiddenSpan.textContent = `${cartData.item_count} items`;
        cartCountBubbleContainer.appendChild(visuallyHiddenSpan);

        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.appendChild(cartCountBubbleContainer);
        }
      }
      cartCountBubble.textContent = cartData.item_count;
      
      const cartDrawerContainer = document.querySelector('cart-drawer');
      if (cartDrawerContainer && cartDrawerContainer.classList.contains('is-empty')) {
        cartDrawerContainer.classList.remove('is-empty');
        const drawerInnerEmpty = cartDrawerContainer.querySelector('.drawer__inner-empty');
        if (drawerInnerEmpty) {
          drawerInnerEmpty.remove();
        }
      }
      const cartDrawerItemsElement = document.querySelector('cart-drawer-items');
      if (cartDrawerItemsElement && typeof cartDrawerItemsElement.onCartUpdate === 'function') {
        cartDrawerItemsElement.onCartUpdate();
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
})
  .catch((error) => {
    console.error('Error:', error);
  });
});

/* Complementary section quickshop */
window.addEventListener('load', function() {
    var parentElements = document.querySelectorAll('.complementary-products .card');
    parentElements.forEach(function(parentElement) {
        var customProductSizes = parentElement.querySelector('.custom-product-sizes');
        if(customProductSizes) {
            var cardContents = parentElement.querySelectorAll('.card__content');
            if(cardContents.length > 1) {
                var cardInformation = cardContents[1].querySelector('.card__information');
                if(cardInformation) {
                    cardInformation.parentNode.insertBefore(customProductSizes, cardInformation.nextSibling);
                }
            }
        }
    });
});









/* Wishlist add to cart functionality */
document.addEventListener('DOMContentLoaded', (event) => {
    const localStorageKey = 'eg_wishlist_v1';

  
    const closeWishlistDrawer = () => {
        const wishlistDrawer = document.querySelector('#eg-wishlist-drawer');
        const offcanvas = bootstrap.Offcanvas.getInstance(wishlistDrawer);
        if (offcanvas) {
            offcanvas.hide();
        }
    };

   
    const addItemToCart = async (productHandle) => {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const product = await response.json();
            const firstVariantId = product.variants[0].id;

            const addToCartResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    id: firstVariantId,
                    quantity: 1
                })
            });

            if (!addToCartResponse.ok) {
                throw new Error(`HTTP error! status: ${addToCartResponse.status}`);
            }

            const cartData = await addToCartResponse.json();
            updateCartCount(cartData);
        } catch (error) {
            console.error('Error adding item to cart:', error);
        }
    };

 
    const updateCartCount = async (cartData) => {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await response.json();
            let cartCountBubble = document.querySelector('.cart-count-bubble span');
            
            if (!cartCountBubble) {
                const cartCountBubbleContainer = document.createElement('div');
                cartCountBubbleContainer.className = 'cart-count-bubble';
                cartCountBubble = document.createElement('span');
                cartCountBubble.setAttribute('aria-hidden', 'true');
                cartCountBubbleContainer.appendChild(cartCountBubble);
                
                const visuallyHiddenSpan = document.createElement('span');
                visuallyHiddenSpan.className = 'visually-hidden';
                visuallyHiddenSpan.textContent = `${cart.item_count} items`;
                cartCountBubbleContainer.appendChild(visuallyHiddenSpan);

                const cartIconBubble = document.querySelector('#cart-icon-bubble');
                if (cartIconBubble) {
                    cartIconBubble.appendChild(cartCountBubbleContainer);
                }
            }
            
            cartCountBubble.textContent = cart.item_count;

            const cartDrawerContainer = document.querySelector('cart-drawer');
            if (cartDrawerContainer && cartDrawerContainer.classList.contains('is-empty')) {
                cartDrawerContainer.classList.remove('is-empty');
                const drawerInnerEmpty = cartDrawerContainer.querySelector('.drawer__inner-empty');
                if (drawerInnerEmpty) {
                    drawerInnerEmpty.remove();
                }
            }
            const cartDrawerItemsElement = document.querySelector('cart-drawer-items');
            if (cartDrawerItemsElement && typeof cartDrawerItemsElement.onCartUpdate === 'function') {
                cartDrawerItemsElement.onCartUpdate();
            }
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            }
        } catch (error) {
            console.error('Error updating cart count:', error);
        }
    };

   
    document.addEventListener('click', (event) => {
        if (event.target.matches('.wishlist-add-to-cart-btn')) {
            event.preventDefault();
            const button = event.target;
            const productHandle = button.getAttribute('data-product-handle');
            closeWishlistDrawer();
            addItemToCart(productHandle);
        }
    });
});




/* Handling of transparent header */
document.addEventListener('DOMContentLoaded', function() {
  const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');
  const sectionHeader = document.querySelector('.section-header');

  function addScrolledPastHeaderClass() {
    sectionHeader.classList.add('scrolled-past-header');
  }

  function removeScrolledPastHeaderClass() {
    sectionHeader.classList.remove('scrolled-past-header');
  }

  const observer = new MutationObserver(function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const menuOpening = menuDrawerContainer.classList.contains('menu-opening');
        if (menuOpening) {
          addScrolledPastHeaderClass();
        } else {
          removeScrolledPastHeaderClass();
        }
      }
    }
  });

  observer.observe(menuDrawerContainer, { attributes: true });

  const initialMenuOpening = menuDrawerContainer.classList.contains('menu-opening');
  if (initialMenuOpening) {
    addScrolledPastHeaderClass();
  }
});










































